module.exports = __webpack_public_path__ + "static/media/013.72364b62.jpg";